module.exports = __webpack_public_path__ + "img/des_happy_2.8bf66ba3.jpg";